var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrollbar",style:(_vm.style),attrs:{"id":("style-" + _vm.type)}},[_c('div',{staticClass:"force-overflow"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }